import React, { useRef } from 'react'
import { Button } from 'native-base'
import { useTranslation } from 'react-i18next'
import { useAlertDialog } from '../../../../components/AlertDialog'
import { TouchableOpacity } from 'react-native'
import { FontAwesomeIcon } from '@webstollen/react-native/lib/fontawesome'
import useStyles from './styles'
import { useHistory } from '@webstollen/react-native/lib/react-router'
import BoldText from '@webstollen/react-native/lib/components/CustomText/BoldText'
import { useHighlightColor } from '@webstollen/react-native/lib/hooks/useColors'
import icons from '../../../../constants/icons'

const SetDashboardAsMainButtonWithModal = ({
  setDashboardAsMain,
  mayManageDashboard,
  dashboardTitle,
}: {
  setDashboardAsMain: () => Promise<void>
  mayManageDashboard: boolean
  dashboardTitle: string
}) => {
  const styles = useStyles()
  const history = useHistory()
  const { t } = useTranslation()
  const highlightColor = useHighlightColor()

  const cancelRef = useRef(null)
  const { AlertDialog, open, close, alertDialogProps } = useAlertDialog({ leastDestructiveRef: cancelRef })

  return (
    <>
      <TouchableOpacity
        onPress={() => {
          if (mayManageDashboard) {
            open()
          } else {
            history.push('/upselling')
          }
        }}
        style={styles.manageDashboardButton}
      >
        <FontAwesomeIcon icon={[icons.faIconStyle, 'cog']} color={highlightColor} />
        <BoldText style={[styles.widgetText, { color: highlightColor }]}>{t('dashboard.setAsMain')}</BoldText>
      </TouchableOpacity>
      <AlertDialog {...alertDialogProps}>
        <AlertDialog.Content>
          <AlertDialog.CloseButton />
          <AlertDialog.Header>{t('dashboard.setAsMain')}</AlertDialog.Header>
          <AlertDialog.Body>{t('dashboard.setAsMainText', { dashboard: dashboardTitle })}</AlertDialog.Body>
          <AlertDialog.Footer>
            <Button.Group space={2}>
              <Button variant="unstyled" colorScheme="coolGray" onPress={close} ref={cancelRef}>
                {t('dashboard.widgets.delete.cancel')}
              </Button>
              <Button
                colorScheme="primary"
                onPress={() => {
                  setDashboardAsMain().then(() => history.push('/settings/dashboard'))
                }}
              >
                {t('dashboard.setAsMain')}
              </Button>
            </Button.Group>
          </AlertDialog.Footer>
        </AlertDialog.Content>
      </AlertDialog>
    </>
  )
}

export default SetDashboardAsMainButtonWithModal
